<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'Cross',
    },
    isDecorative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ariaLabel() {
      return this.isDecorative ? null : this.title
    },
  },
}
</script>
<template>
  <svg
    role="img"
    :aria-label="ariaLabel"
    :aria-hidden="isDecorative"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 19 19 5M19 19 5 5"
    />
  </svg>
</template>
